<template>
  <div class="home-page">
    <!-- Navbar -->
    <navbar-home></navbar-home>

    <section class="ew-smaller-container ew-bigger-line-height mb-5">
      <h3 class="ew-section-header">Aviso de Privacidad</h3>

      <div>
        <p>
          La protección de sus datos personales es muy importante. Este Aviso de Privacidad, elaborado conforme a buenas
          prácticas internacionales y a la Ley Federal de Protección de Datos Personales en Posesión de los
          Particulares,
          tiene como fin informarle sobre los datos personales que recabamos, cómo los usamos, manejamos y compartimos,
          con el
          objetivo de garantizar su derecho a la autodeterminación informativa.
        </p>

        <h5 class="text-primary font-weight-bold alt-font">I. Glosario</h5>
        <p><strong>Titular:</strong> Persona física a quien corresponden los datos personales.</p>
        <p><strong>Responsable:</strong> Persona física o moral que decide sobre el tratamiento de los datos personales.
        </p>
        <p><strong>Encargado:</strong> Persona física o moral que trata datos personales por cuenta del responsable.</p>
        <p><strong>Registro:</strong> Información proporcionada al usar los sitios o servicios, como nombre, correo
          electrónico, teléfono, dirección y otros datos de identificación.</p>
        <p><strong>Tratamiento:</strong> Toda operación realizada con datos personales, como recopilación,
          almacenamiento, uso y comunicación.</p>
        <p><strong>Transferencia:</strong> Comunicación de datos personales a terceros.</p>
        <p><strong>Derechos ARCO:</strong> Derechos de Acceso, Rectificación, Cancelación y Oposición.</p>
        <p><strong>Consentimiento tácito:</strong> Se entiende que el titular ha consentido el tratamiento de sus datos
          cuando no manifiesta oposición tras conocer este aviso.</p>

        <h5 class="text-primary font-weight-bold alt-font">II. Categorías de Datos</h5>
        <p><strong>Datos de identificación:</strong> Nombre, CURP, RFC, fecha de nacimiento, nacionalidad, fotografía,
          entre otros.</p>
        <p><strong>Datos de contacto:</strong> Domicilio, correo electrónico, teléfono, entre otros.</p>
        <p><strong>Datos laborales:</strong> Empleo, cargo, desempeño laboral, referencias, entre otros.</p>
        <p><strong>Datos patrimoniales o financieros:</strong> Bienes, ingresos, cuentas bancarias, historial
          crediticio, seguros, entre otros.</p>
        <p><strong>Datos biométricos:</strong> Huella dactilar, imagen del iris, palma de la mano u otros análogos.</p>
        <p><strong>Datos sensibles:</strong> Opiniones políticas, religiosas, ideológicas, salud, vida sexual, origen
          étnico o racial, afiliación sindical.</p>
        <p><strong>Datos tecnológicos:</strong> Cookies, web beacons y uso de servicios, que permiten identificar y
          mejorar la experiencia del usuario.</p>

        <h5 class="text-primary font-weight-bold alt-font">III. Cómo recopilamos los datos</h5>
        <p>Recopilamos información mediante:</p>
        <ul>
          <li>Formularios web.</li>
          <li>Registros de interacción en nuestros sitios y servicios.</li>
          <li>Fuentes públicas y datos proporcionados por terceros confiables.</li>
        </ul>

        <h5 class="text-primary font-weight-bold alt-font">IV. Finalidades del tratamiento</h5>
        <p>Los datos personales se utilizarán para:</p>
        <ul>
          <li>Prestar servicios y dar atención al cliente.</li>
          <li>Realizar campañas informativas o promocionales.</li>
          <li>Actualizar bases de datos y generar reportes internos.</li>
          <li>Gestionar pagos, facturación y obligaciones legales.</li>
        </ul>

        <h5 class="text-primary font-weight-bold alt-font">V. Derechos ARCO</h5>
        <p>El titular puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición enviando una
          solicitud con:</p>
        <ol class="ew-list-latin-styles">
          <li>Nombre completo, domicilio y correo electrónico.</li>
          <li>Motivo de la solicitud.</li>
          <li>Argumentos y documentos que sustenten la solicitud.</li>
          <li>Documento oficial que acredite su identidad.</li>
        </ol>

        <h5 class="text-primary font-weight-bold alt-font">VI. Revocación del consentimiento</h5>
        <p>El titular puede revocar su consentimiento respecto del tratamiento de sus datos personales enviando una
          solicitud con los mismos requisitos que para ejercer los derechos ARCO.</p>

        <h5 class="text-primary font-weight-bold alt-font">VII. Seguridad y limitación de uso</h5>
        <p>Se aplican medidas de seguridad administrativas, técnicas y físicas para proteger los datos personales y
          limitar su uso o divulgación sin autorización.</p>

        <h5 class="text-primary font-weight-bold alt-font">VIII. Cambios al Aviso de Privacidad</h5>
        <p>Nos reservamos el derecho de actualizar este aviso. Los cambios serán publicados en nuestro sitio web y
          estarán disponibles para consulta.</p>

        <h5 class="text-primary font-weight-bold alt-font">IX. Contacto</h5>
        <p>Para ejercer derechos ARCO, revocar consentimiento o solicitar información adicional sobre privacidad, puede
          contactarnos en:</p>
        <p><strong>Correo electrónico:</strong> privacidad@example.com</p>
        <p><strong>Teléfono:</strong> +52 55 1234 5678</p>
      </div>
    </section>

    <!-- Footer global -->
    <AppFooter />
  </div>
</template>
<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "@/components/Header/NavbarHome.vue";

export default {
  name: 'PrivacyAdvice',
  data() {
    return {
    }
  },
  watch: {

  },
  methods: {
  },
  computed: {

  },
  created() { },
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
p,
ol li,
ul li,
h5 {
  text-align: justify;
}

.ew-loading-indicator {
  min-height: 100vh;
  background-color: #ededed;

  .inner-container {
    min-height: 100vh;
    background-color: white;
    min-width: 80%;
    max-width: 1340px;
    margin: 0 auto;
  }
}

.ew-icon {
  width: 1.3rem;
  height: 1.3rem;
}

.ew-card-services {
  width: 100px;
  height: 100 px;
}

.flotante-wa {
  bottom: 7rem !important;
}

.flotante {
  display: scroll;
  position: fixed;
  bottom: 2rem;
  left: 1.5rem;
  color: #fff;
  background: #0057ba;
  border-radius: 50%;
  border: 0 none;
  -webkit-box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  width: 65px;
  height: 65px;
  text-align: center;
  line-height: 65px;
}

@media (max-width: 767px) {
  .flotante-wa {
    bottom: 6.2rem;
  }

  .flotante {
    bottom: 1.2rem;
    left: 1.4rem;
    width: 48px;
    height: 48px;
    line-height: 48px;
  }

  .flotante img {
    width: 22px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyAdvice.vue